/* >> TriplePixel :: start*/
~function(W,H,A,L,E){try{A.setItem(H,1+(0|A.getItem(H)||0)),W.includes("⇈")&&A.setItem(H+"Stg",1+(0|A.getItem(H+"Stg")||0))}catch(e){}function O(T,R){void 0===R&&(R=!1),H=new XMLHttpRequest,H.open("GET","//triplewhale-pixel.web.app/triplepx.txt?"+~(Date.now()/9e7),!0),H.send(null),H.onreadystatechange=function(){4===H.readyState&&200===H.status?setTimeout(function(){return eval(H.responseText)},50):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(T-1))}}A=window,A[H]||(L=function(){return"tp.."+Date.now().toString(36)+Math.random().toString(36)},E=A[H]=function(t,e,n){return W=L(),(E._q=E._q||[]).push([W,e,n]),W},E.ch=W,O(5))}("","TriplePixel",localStorage);
/* << TriplePixel :: end*/


window.dataLayer = window.dataLayer || [];
function gtag() {
 dataLayer.push(arguments);
}
gtag("js", new Date());

gtag("config", "AW-855343964");

function gtag_report_conversion(url) {
 var callback = function () {
   if (typeof url != "undefined") {
     window.location = url;
   }
 };
 console.log("I called a gtag conversion");
 /*
  gtag('event', 'conversion', {
    'send_to': 'AW-855343964/9_PsCOjCg8YDENyG7pcD',
    'event_callback': callback
  });*/
 return false;
}